import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { Fonts } from '../../config/theme';
import Wrapper from './custom_select.styled';

export interface Option {
  label: string;
  value: string;
  default?: boolean;
  style?: React.CSSProperties;
}

export interface OptionWithObj {
  label: any;
  value: string;
  default?: boolean;
  style?: React.CSSProperties;
}

interface CustomSelectProps {
  options: Option[] | OptionWithObj[];
  dropdownIcon?: any; // TODO fix any
  className?: string;
  style?: React.CSSProperties;
  value?: string;
  onChange?: (arg: any) => void;
}

function CustomSelect({
  options,
  dropdownIcon,
  className,
  style,
  value,
  onChange,
}: CustomSelectProps) {
  const [screen, setScreen] = useState<Option>({
    label: '',
    value: '',
  });
  const [dropdown, setDropdown] = useState(false);

  // set default value
  useEffect(() => {
    options?.forEach((option) => {
      if (option.default === true) {
        setScreen({
          ...options,
          label: option.label,
          value: option.value,
        });
      }
    });
  }, [options]);

  useEffect(() => {
    if (value) {
      options?.forEach((item) => {
        item.default = false;
        if (item.value === value) {
          item.default = true;
          setScreen({
            ...screen,
            label: item.label,
            value: item.value,
          });
        }
      });
      setDropdown(false);
    }
  }, [value]);

  useEffect(() => {
    if (screen) {
      onChange ? onChange(screen) : null;
    }
  }, [screen]);

  // set display value
  function handleClick(optionValue: string) {
    options?.forEach((item) => {
      item.default = false;
      if (item.value === optionValue) {
        item.default = true;
        setScreen({
          ...screen,
          label: item.label,
          value: item.value,
        });
      }
    });
    onChange ? onChange(optionValue) : null;
    setDropdown(false);
  }

  // set blur function
  function handleBlur(event: React.FocusEvent<HTMLDivElement>) {
    if (!event.currentTarget.contains(event.relatedTarget as Node)) {
      setDropdown(false);
    } else {
      setDropdown(true);
    }
  }

  const variants = {
    hidden: {
      y: 50,
      opacity: 0,
      transition: { duration: 0.5 },
    },
    show: {
      y: [50, 0],
      opacity: [0, 1],
      transition: { duration: 0.5 },
    },
    exit: {
      y: [0, 50],
      opacity: [1, 0],
      transition: { duration: 0.5 },
    },
  };
  return (
    <Wrapper>
      <div className="select lato-font" onBlur={handleBlur}>
        <button
          className={`value-container ${className}`}
          onClick={() => {
            setDropdown(!dropdown);
          }}
          style={style}
        >
          <div
            style={{
              display: 'flex',
            }}
          >
            <p className="value">{screen.value}</p>
            <div className="icon">{dropdownIcon}</div>
          </div>
        </button>
        <AnimatePresence {...(dropdown && { initial: false })}>
          {dropdown && (
            <motion.div
              className="dropdown"
              initial="hidden"
              animate="show"
              exit="hidden"
              variants={variants}
            >
              {options?.map((option) => (
                <button
                  key={option.value}
                  onClick={() => handleClick(option.value)}
                  className={option.default ? 'selected' : ''}
                  style={{
                    margin: '5px',
                    fontFamily: Fonts.secondary,
                    ...style,
                  }}
                >
                  <span style={option.style}>{option?.value}</span>
                </button>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Wrapper>
  );
}

export default CustomSelect;
